import React, { useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";
import ErrorBoundary from "./appwide/ErrorBoundary";
import { Container } from "react-bootstrap";
import CookieConsent from "./components/CookieConsent";
import { advertisingActive } from "./utils/trackerGating";

const App = () => {
  const location = useLocation();
  const hasTrackedInitialPageView = useRef(false);

  // Trackers are NOT started here. CookieConsent applies whatever the visitor has
  // already chosen (and shows the banner when they have not chosen yet), so nothing
  // third-party loads on a first visit.

  // SPA support: the Meta Pixel's base code tracks the initial PageView once on load.
  // We track PageView on client-side route changes, skipping the initial render to
  // avoid duplicating it.
  useEffect(() => {
    if (!hasTrackedInitialPageView.current) {
      hasTrackedInitialPageView.current = true;
      return;
    }

    if (!advertisingActive()) return;
    window.fbq("track", "PageView");
  }, [location.pathname, location.search]);

  return (
    <>
      <ErrorBoundary>
        <Container fluid="lg">
          <Outlet />
        </Container>
      </ErrorBoundary>
      <CookieConsent />
    </>
  );
};

export default App;
